import { UIMRoomPlayersController } from './UIMRoomPlayersController.ts';
import { UIMRoomSettingsController } from './UIMRoomSettingsController.ts';
import { uiManager } from '../../EntryMobile.ts';
import { UIMFullscreenTabView } from './UIMFullscreenTabView.ts';
import { RoomStep } from './UIMCreateRoomController.ts';
import { createDiv } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMInviteFriendsBottomDrawer } from '../../ui_popup/UIMInviteFriendsBottomDrawer.ts';
var RoomPageTabs = /*#__PURE__*/ function(RoomPageTabs) {
    RoomPageTabs[RoomPageTabs["Settings"] = 0] = "Settings";
    RoomPageTabs[RoomPageTabs["Players"] = 1] = "Players";
    return RoomPageTabs;
}(RoomPageTabs || {});
export class UIMRoomPageController {
    createAdElement() {
        const adContainer = createDiv('banner_private_ad');
        this.roomPageView.body.prepend(adContainer);
        uiManager.adController.showLobbyVerticalAds();
    }
    initializeControllers() {
        this.roomSettingsController = new UIMRoomSettingsController(this.roomPageView.getContainerWithTabIdx(0), this.roomState, (idx)=>uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.EditRoom, true, idx), true);
        this.roomPlayersController = new UIMRoomPlayersController(this.roomPageView.getContainerWithTabIdx(1), this.roomState);
    }
    update(roomState) {
        this.roomState = roomState;
        UIMInviteFriendsBottomDrawer.updateRoomState(roomState);
        const newHeader = {
            key: 'strings:roomPage.notifications.hash',
            options: {
                roomID: roomState.gameSetting.id
            }
        };
        this.roomPageView.updateHeader(newHeader);
        const playerText = {
            key: 'strings:roomPage.notifications.playerCount',
            options: {
                count: roomState.getSessionCount(),
                maxCount: roomState.gameSetting.maxPlayers
            }
        };
        this.roomPageView.setTabTitle(1, playerText);
        this.roomSettingsController.update(roomState);
        this.roomPlayersController.update(roomState);
    }
    receivedChatMessage(avatar, message, username) {
        var _this_roomPlayersController_chatController, _this_roomPlayersController;
        (_this_roomPlayersController = this.roomPlayersController) === null || _this_roomPlayersController === void 0 ? void 0 : (_this_roomPlayersController_chatController = _this_roomPlayersController.chatController) === null || _this_roomPlayersController_chatController === void 0 ? void 0 : _this_roomPlayersController_chatController.receivedChatMessage(avatar, message, username);
    }
    showView(tabIndex) {
        this.roomPageView.show();
        if (tabIndex != undefined) this.roomPageView.updateActiveTabToIndex(tabIndex);
    }
    hideView() {
        this.roomPageView.updateActiveTabToIndex(1);
        this.roomPlayersController.chatController.clearMessages();
        this.roomPageView.hide();
    }
    constructor(roomState){
        this.roomState = roomState;
        const title = {
            key: 'strings:roomPage.notifications.hash',
            options: {
                roomID: roomState.gameSetting.id
            }
        };
        const tabProperties = [
            {
                title: {
                    key: 'strings:game.gearIcon.settings'
                },
                isActive: false,
                containerClass: 'm-room-settings-cards-container',
                id: 0
            },
            {
                title: {
                    key: 'strings:roomPage.notifications.playerCount',
                    options: {
                        count: 1,
                        maxCount: 4
                    }
                },
                isActive: true,
                containerClass: 'm-room-players-main-container',
                id: 1
            }
        ];
        this.roomPageView = new UIMFullscreenTabView(title, tabProperties, undefined, (tabIdx)=>{
            if (tabIdx != 0) return;
            this.roomSettingsController.update(this.roomState) // Feb 23, 2024. Mau: Since the safe and warning slider zone percentage is based on the tick's position on the screen, we should recalculate it when switching tabs to prevent calculation errors on a hidden tab.
            ;
        });
        this.createAdElement();
        this.initializeControllers();
    }
}
